import {AfterViewInit, Component, ElementRef, OnInit, OnDestroy} from '@angular/core';

import {filter, pairwise} from 'rxjs/operators';

import {NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RoutesRecognized} from '@angular/router';
import {Location} from '@angular/common';
import {Subscription} from 'rxjs';

import {Globals} from './core/services/globals';
import {TrackingService} from "./core/services/tracking.service";


declare let ga: Function;

@Component({
  selector: 'my-root',
  template: `
    <div
      infiniteScroll
      [immediateCheck]="true"
      [fromRoot]="true"
      [infiniteScrollDistance]="3"
      [infiniteScrollUpDistance]="4"
      [infiniteScrollThrottle]="0"
      (scrolled)="onScrollDown()"
      (scrolledUp)="onScrollUp()"
      [scrollWindow]="true"
    >
      <router-outlet></router-outlet>
    </div>
  `,
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements AfterViewInit, OnInit, OnDestroy {
  title = 'Tour of Heroes';
  private hostnameStr = '';
  private emailStr = '';
  private propertyTypeStr = '';
  private cityStr = '';
  private minPriceStr = '';
  private maxPriceStr = '';
  private bedroomsNum = '';
  private bathroomsNum = '';
  private userIDStr = '';
  private clientId = '';
  private savedSearchIDStr = '';
  private ipAddrStr = '';
  private sidStr = '';
  private statusStr = '';
  private isRegisteredBln = '';

  private docElem = document.documentElement;
  private didScroll = false;
  private changeHeaderOn = 1;
  private initBln = true;

  private _routeScrollPositions: Record<string, number> = {};
  private _subscriptions: Subscription[] = [];

  private time = 0;
  private display = '';
  private interval: ReturnType<typeof setInterval> | undefined;

  constructor(
    private router: Router,
    private location: Location,
    elementRef: ElementRef,
    public globals: Globals,
    private trackingService: TrackingService
  ) {
    // Verify the service is properly injected
    console.log('Globals service in constructor:', globals);

    // Subscribe to changes
    this.globals.globals$.subscribe(state => {
      console.log('Global state changes:', state.districtList);
    });

    // DEBUG
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        console.log('Navigation started:', event.url);
      }
      if (event instanceof NavigationEnd) {
        console.log('Navigation ended:', event.url);
      }
      if (event instanceof NavigationError) {
        console.error('Navigation error:', event.error);
      }
      if (event instanceof NavigationCancel) {
        console.warn('Navigation cancelled');
      }
    });


    // define properties
    this.hostnameStr = elementRef.nativeElement.getAttribute('hostnameStr');
    this.emailStr = elementRef.nativeElement.getAttribute('emailStr');
    this.propertyTypeStr =
      elementRef.nativeElement.getAttribute('propertyTypeStr');
    this.cityStr = elementRef.nativeElement.getAttribute('cityStr');
    this.minPriceStr = elementRef.nativeElement.getAttribute('minPriceStr');
    this.maxPriceStr = elementRef.nativeElement.getAttribute('maxPriceStr');
    this.bedroomsNum = elementRef.nativeElement.getAttribute('bedroomsNum');
    this.bathroomsNum = elementRef.nativeElement.getAttribute('bathroomsNum');
    this.userIDStr = elementRef.nativeElement.getAttribute('userIDStr');
    this.clientId = elementRef.nativeElement.getAttribute('clientId');
    this.savedSearchIDStr =
      elementRef.nativeElement.getAttribute('savedSearchIDStr');
    this.ipAddrStr = elementRef.nativeElement.getAttribute('ipAddrStr');
    this.sidStr = elementRef.nativeElement.getAttribute('sidStr');
    this.statusStr = elementRef.nativeElement.getAttribute('statusStr');
    this.isRegisteredBln =
      elementRef.nativeElement.getAttribute('isRegisteredBln');
    // set the passed parameters into the globals for external reference
    if (this.hostnameStr != '') {
      globals.hostnameStr = this.hostnameStr;
    }
    if (this.emailStr != '') {
      globals.emailStr = this.emailStr;
    }
    if (this.propertyTypeStr != '') {
      globals.propertyTypeStr = this.propertyTypeStr;
    }
    if (this.minPriceStr != '') {
      globals.searchMin = this.minPriceStr;
    }
    if (this.maxPriceStr != '') {
      globals.searchMax = this.maxPriceStr;
    }
    if (this.bedroomsNum != '') {
      globals.bedroomsNum = this.bedroomsNum;
    }
    if (this.bathroomsNum != '') {
      globals.bathroomsNum = this.bathroomsNum;
    }
    if (this.userIDStr != '') {
      globals.userIDStr = this.userIDStr;
    }
    if (this.clientId != '') {
      globals.clientId = this.clientId;
    }
    if (this.savedSearchIDStr != '') {
      globals.savedSearchIDStr = this.savedSearchIDStr;
    }
    if (this.ipAddrStr != '') {
      globals.ipAddrStr = this.ipAddrStr;
    }
    if (this.sidStr != '') {
      globals.sidStr = this.sidStr;
    }
    if (this.statusStr != '') {
      globals.statusStr = this.statusStr;
    }
    if (this.isRegisteredBln != '' && this.emailStr != '') {
      globals.isRegisteredBln = this.isRegisteredBln;
    }
    if (router.url == '/search/toronto') {
      globals.districtList = 'Toronto';
    }
    // switch, based on the user defined domain then load the correct listings
    switch (this.hostnameStr) {
      case 'oakvillesluxuryrealestate.com':
        globals.districtList = 'Oakville';
        globals.siteIDStr = 3069;
        break;
      case 'mississaugasluxuryrealestate.com':
        globals.districtList = 'Mississauga';
        globals.siteIDStr = 3069;
        break;
      case 'southcaymanmarshall.com':
        globals.districtList = 'Mississauga';
        globals.siteIDStr = 3073;
        break;
      case 'portcreditluxuryrealestate.com':
        globals.districtList = 'Port Credit';
        globals.enableExclusiveListingsBln = false;
        globals.siteIDStr = 3072;
        break;
      case 'mineolaluxuryrealestate.com':
        globals.districtList = 'Mineola';
        globals.enableExclusiveListingsBln = false;
        globals.siteIDStr = 3070;

        console.log('setting district to Mineola');
        console.log('Current district value:', globals.districtList);


        break;
      case 'lorneparkluxuryrealestate.ca':
        globals.districtList = 'Lorne Park';
        globals.enableExclusiveListingsBln = false;
        globals.siteIDStr = 3071;
        break;
      case 'burlingtonluxuryrealestate.com':
        globals.districtList = 'Burlington';
        globals.enableExclusiveListingsBln = false;
        globals.siteIDStr = 3074;
        break;
    }
    console.log('District List value:', globals.districtList);

    if (this.cityStr != '') {
      globals.districtList = this.cityStr;
    }
    // fork, determine if the user has used the lead capture domains, if so then disable the links
    globals.linksEnabledBln = !(this.hostnameStr == 'oakvillesluxuryrealestate.com' ||
      this.hostnameStr == 'mississaugasluxuryrealestate.com' ||
      this.hostnameStr == 'burlingtonluxuryrealestate.com' ||
      this.hostnameStr == 'southcaymanmarshall.com' ||
      this.hostnameStr == 'portcreditluxuryrealestate.com' ||
      this.hostnameStr == 'mineolaluxuryrealestate.com' ||
      this.hostnameStr == 'lorneparkluxuryrealestate.ca');
    console.log('District List value:', globals.districtList);


    // Capture UTM parameters from the URL if present and store in session storage
    this.captureUTMParams();

    // create the listener for page changes and send the google analytics data
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        //console.log('previous URL: ' + event.url);
        // fork, if this is the homepage then make sure to log the url
        if (event.url == '/') {
          if (globals.previousURLStr != '' && globals.previousURLStr != event.url) {
            // stop the timer
            this.pauseTimer();
            this.trackingService.trackUserJourney(0, 'back', 'Client Clicked back after ' + this.display);
          }
          globals.previousURLStr = '/';
        } else {
          // start the timer
          this.startTimer();
          globals.previousURLStr = event.url;
        }
        //ga('set', 'page', event.urlAfterRedirects);
        //ga('send', 'pageview');
        (window as any).dataLayer.push({
          userIDStr: globals.userIDStr,
          sidStr: globals.sidStr,
          event: 'pageview',
          page: {
            path: event.urlAfterRedirects,
          },
        });
      }
    });
  }

  ngOnInit(): void {
    // console.log('ngOnInit');
    // define properties
    this.router.events.subscribe((event) => {
      // console.log('init: ' + event);
      const header = document.querySelector('.navbar-default');
      const changeHeaderOn = this.changeHeaderOn;
      const sy = this.scrollY();
      // example: NavigationStart, RoutesRecognized, NavigationEnd
      // console.log(event);
      if (sy >= changeHeaderOn && header != null) {
        // console.log(sy);
        header.classList.add('navbar-shrink');
      }
      const element = document.querySelector('.intro-heading');
      //if (element) element.scrollIntoView(element);

      //window.scrollTo(0, 0);
    });
  }

  ngAfterViewInit(): void {
    // console.log('ngAfterViewInit');
    const header = document.querySelector('.navbar-default');
    const changeHeaderOn = this.changeHeaderOn;
    const sy = this.scrollY();
    if (sy >= changeHeaderOn && header != null) {
      header.classList.add('navbar-shrink');
    }

    this.router.events
      .pipe(
        filter((evt: any) => evt instanceof RoutesRecognized),
        pairwise(),
      )
      .subscribe((events: RoutesRecognized[]) => {
        // url path without parameters
        const urlPathStr = events[0].urlAfterRedirects.split(';', 1)[0];
        setTimeout(() => this.getScrollTop('resultsList', urlPathStr), 0);
      });
    /*

    // restore scroll position on back or forward for the results view
    this.location.subscribe(event => {
        // back or forward, wait for router navigation end
        let routerNavigationEnd = this.router.events.first(event => event instanceof NavigationEnd)
            .subscribe((navigationEndEvent: NavigationEnd) => {
                // url path without parameters
                let urlPathStr= (navigationEndEvent.urlAfterRedirects || navigationEndEvent.url).split(';',1)[0];
                //setTimeout(this.setScrollTo('resultsList', urlPathStr), 0);
            });
    });*/
  }

  getScrollTop(nodeIdStr: string, urlPathStr: string) {
    const node = document.getElementById(nodeIdStr);
    if (node) {
      let scrollTopNum = node.scrollTop;
      if (scrollTopNum == 0) {
        // console.log('mobile version');
        // set the mobile version boolean indicator
        this.globals.mobileBln = true;
        scrollTopNum = this.scrollY();
        // console.log(document.documentElement.scrollTop);
      } else {
        // make sure to set the mobile version boolean indicator to false
        this.globals.mobileBln = false;
      }
      this._routeScrollPositions[urlPathStr] = scrollTopNum;
      this.globals.scrollTopNum = scrollTopNum;
      // console.log('offset: ' + scrollTopNum);
      // console.log(window);
    }
  }

  onScrollDown() {
    // console.log("scrolled down!!");
    const header = document.querySelector('.navbar-default');
    if (header == null) {
      return;
    }
    const changeHeaderOn = this.changeHeaderOn;
    const sy = this.scrollY();
    if (sy >= changeHeaderOn) {
      header.classList.add('navbar-shrink');
    }
  }

  onScrollUp() {
    // console.log("scrolling up");
    const header = document.querySelector('.navbar-default');
    if (header == null) {
      return;
    }
    const changeHeaderOn = this.changeHeaderOn;
    const sy = this.scrollY();
    // console.log('changing header:' + sy);
    if (sy <= changeHeaderOn) {
      header.classList.remove('navbar-shrink');
    }
  }

  scrollY() {
    return window.pageYOffset || this.docElem.scrollTop;
  }

  captureUTMParams() {
    const urlParams = new URLSearchParams(window.location.search);
    console.log(urlParams);

    const utmSource = urlParams.get('utm_source');
    const utmMedium = urlParams.get('utm_medium');
    const utmCampaign = urlParams.get('utm_campaign');
    const utmTerm = urlParams.get('utm_term');
    const utmContent = urlParams.get('utm_content');

    // If UTM parameters are present, store them in session storage
    if (utmSource) {
      sessionStorage.setItem('utm_source', utmSource);
    }
    if (utmMedium) {
      sessionStorage.setItem('utm_medium', utmMedium);
    }
    if (utmCampaign) {
      sessionStorage.setItem('utm_campaign', utmCampaign);
    }
    if (utmTerm) {
      sessionStorage.setItem('utm_term', utmTerm);
    }
    if (utmContent) {
      sessionStorage.setItem('utm_content', utmContent);
    }

    // Optionally, store the UTM params in the globals if you need to use them elsewhere
    if (utmSource) {
      this.globals.utmSource = utmSource;
    }
    if (utmMedium) {
      this.globals.utmMedium = utmMedium;
    }
    if (utmCampaign) {
      this.globals.utmCampaign = utmCampaign;
    }
    if (utmTerm) {
      this.globals.utmTerm = utmTerm;
    }
    if (utmContent) {
      this.globals.utmContent = utmContent;
    }
  }

  startTimer() {
    this.interval = setInterval(() => {
      if (this.time === 0) {
        this.time++;
      } else {
        this.time++;
      }
      this.display = this.transform(this.time)
    }, 1000);
  }

  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    return minutes + ' minutes and ' + (value - minutes * 60) + ' seconds';
  }

  pauseTimer() {
    clearInterval(this.interval);
  }

  ngOnDestroy() {
    this._subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
